import { defineMessages } from "react-intl";

const messages = defineMessages({
  displayVariants: {
    defaultMessage: "Display variant grid",
    id: "mn9U7T",
    description: "product variants hidden, display variant grid",
  },
  goToDefaultVariant: {
    defaultMessage: "Go to default variant",
    id: "SoCu3i",
    description: "product variants hidden, go to default",
  },
});

export default messages;
